import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Link from 'next/link';
import { USER_TYPE } from 'libs/constants';
import { useGetNotificationsQuery } from 'store/api';
import Box from '@mui/system/Box';
import { AuthSession } from 'hooks/useAuth';
import {
  AuthWrapper,
  SignInBtn,
  AuthUserName,
  LoggedInAuthWrapper,
  RegBtn
} from './styled';
import NotificationMenu from './NotificationMenu';
import ProfileMenu from './ProfileMenu';
import { notificationOptions } from './authUserMenuData';

function Auth({ mobileView }: { mobileView?: boolean }): JSX.Element {
  const auth = AuthSession();
  const [hasUnacknowledged, setHasUnacknowledged] = useState(false);
  const [notifications, setNotifications] = useState<null | Notifications>(
    null
  );
  const userId = auth.user && auth.user.id;
  const { data: notificationsData, isLoading } = useGetNotificationsQuery(
    userId,
    {
      skip: !auth.isAuthenticated || !userId
    }
  );

  useEffect(() => {
    if (!isLoading && notificationsData) {
      for (let i = 0; i < notificationOptions.length; i += 1) {
        if (
          notificationOptions[i].unAcknowledgedKey &&
          notificationsData[notificationOptions[i].unAcknowledgedKey]
        ) {
          setHasUnacknowledged(true);
          break;
        }
      }
      setNotifications(notificationsData);
    }
  }, [notificationsData, isLoading]);

  const resetNotificationAcknowledgeState = () => {
    if (hasUnacknowledged) setHasUnacknowledged(false);
  };

  if (auth.isAuthenticated === undefined) return null;

  if (auth.isAuthenticated && auth.user) {
    const userType = auth.user.isAdvisor
      ? USER_TYPE.advisor
      : USER_TYPE.consumer;
    return (
      <LoggedInAuthWrapper>
        <Box
          sx={{
            alignContent: 'right',
            alignItems: 'right',
            textAlign: 'right'
          }}>
          {!mobileView && (
            <AuthUserName>Welcome {auth.user.username}</AuthUserName>
          )}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'right',
              textAlign: 'right',
              justifyContent: 'right',
              color: 'white'
            }}>
            <NotificationMenu
              userId={userId}
              hasUnacknowledged={hasUnacknowledged}
              notifications={notifications}
              userType={userType}
              resetNotificationAcknowledgeState={
                resetNotificationAcknowledgeState
              }
            />
            {!mobileView && <ProfileMenu userType={userType} />}
          </Box>
        </Box>
      </LoggedInAuthWrapper>
    );
  }

  if (mobileView) return null;

  return (
    <AuthWrapper>
      <Link
        href="/Registration/LoginStarter.aspx?Mode=StartWithLogin&returnurl=/myaccountredirect"
        passHref>
        <SignInBtn>
          <Button variant="altSecondary" size="comfy" disableElevation>
            Sign In
          </Button>
        </SignInBtn>
      </Link>

      <Link
        href="/Registration/LoginStarter.aspx?Mode=StartWithReg&returnurl=/myaccountredirect&SourceUrl=/"
        passHref>
        <RegBtn>
          <Button variant="altPrimary" size="comfy" disableElevation>
            Register
          </Button>
        </RegBtn>
      </Link>
    </AuthWrapper>
  );
}

Auth.defaultProps = {
  mobileView: false
};

export default Auth;
